module.exports = __webpack_public_path__ + "static/media/ih-login-bg-2052x1152.2c238b62.svg";